export default __webpack_public_path__ + "static/media/sa-10.74e5abef.png";